export enum InputType {
  Autocomplete,
  Checkbox,
  Date,
  IBAN,
  Integer,
  TextField,
  Undefined,
}

export const getFormatter = (type: InputType) => {
  switch (type) {
    case InputType.Autocomplete:
      return (value: any) => value ? value.code : null;
    case InputType.Checkbox:
      return (e: any) => e.target.checked;
    case InputType.Date:
      return (value: any) => value.toISOString();
    case InputType.IBAN:
      return (value: any) => {
        const formatted = value
          .toString()
          .replace(
            /\W/gi,
            ""
          )
          .replace(
            /(.{4})/g,
            "$1 "
          )
          .trim();

        return formatted.toUpperCase();
      };
    case InputType.Integer:
      return (value: any) => Math.round(value);
    case InputType.Undefined:
      return (value: any) => value;
    case InputType.TextField:
      return (e: any) => e.target.value;
    default:
      return (value: any) => value;
  }
};